import React from "react";
import { Pagination } from "@shopify/polaris";

import { usePriceChanges } from "./Context";

export default function (): React.JSX.Element {
  const { totalResources, currentPage, fetch } = usePriceChanges();

  const resourcesPerPage = 20;

  const handleNext = () => {
    fetch(currentPage + 1);
  };

  const handlePrevious = () => {
    fetch(currentPage - 1);
  };

  return (
    <div
      style={{
        margin: "auto",
      }}
    >
      <Pagination
        hasNext={currentPage < Math.ceil(totalResources / resourcesPerPage) - 1}
        hasPrevious={currentPage > 0}
        onNext={handleNext}
        onPrevious={handlePrevious}
        label={`Showing ${currentPage * resourcesPerPage + 1} - ${Math.min((currentPage + 1) * resourcesPerPage, totalResources)} of ${totalResources}`}
        type="table"
        accessibilityLabels={{
          previous: "Previous",
          next: "Next",
        }}
      />
    </div>
  );
}
